import angular from 'angular';
import $ from 'jquery';

const LoginServiceFactory = function loginServiceFactory($log, $http, $q, $rootScope, $filter, jwtHelper, 
                                                         NewBackendService, Dispatcher, endPoints, $state, NewUiService,
                                                         NewMerchantProfileService, StoreService, NewTokenService, TermsService, StorageService) {
  'ngInject';

  let merchantProfile;
  let registryWallet;
  let principleResolve;

  const checkLogin = (response, resolve, loginError, doubleProfile) => {
    if(!doubleProfile){
      principleResolve = resolve;
    } 
    StorageService.setLocalStorage('access_token', response.data.access_token);
    StorageService.setLocalStorage('refresh_token', response.data.refresh_token);
    const securityContext = jwtHelper.decodeToken(response.data.access_token);
    NewUiService.getErrorMessagesMap()
    if(securityContext.authorities.includes("ROLE_BO_ADMIN")){
      $log.debug('login riuscita', response);
      StorageService.setLocalStorage('superAdmin', true);
      $rootScope.$broadcast('SUPER_ADMIN_LOGGED_IN');
      resolve();
    }else{
        NewTokenService.setUserContext(securityContext);
        if (securityContext.profile == "BUSINESS" || securityContext.profile == "CORPORATE") {
          service.getMerchantProfile(securityContext.businessId, true).then((result) => {
            if(service.checkUserRole(result.context.authorities)){
              NewTokenService.setMerchantProfile();
              doubleProfile ? principleResolve(result) : resolve(result);
              TermsService.checkAcceptedMerchantTerms();
              $rootScope.$broadcast('USER_LOGGED_IN');
            }else{
              $rootScope.$broadcast('USER_LOG_ERROR');
            }
          }, (reason) => {
            loginError('Error logging in', reason);
        })
        } else if(securityContext.profile == "CONSUMER"){
          $q((resolve, reject) => {
            var user = "me"
            const isSuperAdmin = StorageService.getLocalStorage('superAdmin');
            if(isSuperAdmin){
              const userContext = JSON.parse(StorageService.getLocalStorage('userContext'));
              user = userContext.id 
            }
            NewBackendService.invokeWebApiGet('/api/usr/v2/users/'+user, true).then((response) => {
              var availableWallets = response.data.availableWallets;
              var corpWallet = availableWallets.find(x => x.walletType === "CORPORATE");
              if(corpWallet){
                service.login(undefined, undefined, true, corpWallet.walletId, StorageService.getLocalStorage('access_token'))
              }else{
                loginError('login.errors.merchant');
                service.softLogout();
              }
              resolve();
            }, reject);
        })
        }else{
          loginError('login.errors.merchant');
          service.softLogout();
        }
      //} 
    }
  };

  const service = {

    checkUserRole: (authorities) => {
      var find = false;
      authorities.forEach(element => {
        if(element.authority == "ROLE_OWNER" || element.authority == "ROLE_MANAGER_BACKOFFICE"){
          find = true;
        }
      });
      return find; 
    },

    checkCachedProfile: () => {
      const cachedProfile = NewTokenService.getUserContext();
      if (cachedProfile !== undefined && cachedProfile !== '') { // user was previously logged in
        if (NewTokenService.isMerchant()) {
          NewTokenService.setMerchantProfile();

          // GOOGLE ANALYTICS
          const userContext = angular.fromJson(cachedProfile);
          if (userContext && 'idWallet' in userContext) {
            ga('set', 'userId', userContext.idWallet); // eslint-disable-line
          }
        }
        TermsService.checkAcceptedMerchantTerms();
      }else{
        $rootScope.$broadcast('USER_LOGGED_OUT');
      }
    },
    getRegistryWallet: () => registryWallet,
    getMerchantProfile: (businessId, forceCall = false) => $q((resolve, reject) => {
      if (forceCall || !merchantProfile) {
        console.log("inside getMechantProfile loginFactory")
        NewMerchantProfileService.getMerchantProfile(true, false).then((merchantProfileResult) => {
          NewMerchantProfileService.getMerchantBusiness(businessId).then((resp) => {
            merchantProfile = merchantProfileResult;
            if(resp.data._embedded)
              merchantProfile.business = resp.data._embedded.businesses.length > 0 ? resp.data._embedded.businesses[0] : {};
            else{
              merchantProfile.business = resp.data;
            } 
            StorageService.setLocalStorage("userContext", JSON.stringify(merchantProfile));
            resolve(merchantProfile);
          })
        }, reject);
      } else {
        resolve(merchantProfile);
      }
    }),

    getWalletLevelLabel: () => {
      const user = angular.fromJson(StorageService.getLocalStorage("securityContext"))
      if(user){
        let label = 'common.levels.';
        let userType = user.profile.toLowerCase();
        let level = user.walletLevel;
        return label+userType+"."+level;
      }
      return "";
    },

    switchToken: (walletId) => $q((resolve, reject) => { 
      //service.softLogout();
      const body = $.param({
        'grant_type': 'switch_token',
        "client_id": "webapp",
        "activeWalletId" : walletId,
        "access_token": StorageService.getLocalStorage("access_token")
      });
      $http.post(`${endPoints.baseUrl}${endPoints.authenticatorUrl}`, body, {
          ignoreAuthModule: true,
          customErrorManagement: true,
          headers: {
            'Authorization': 'Basic d2ViYXBwOndlYmFwcF9zZWNyZXQ=',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': "application/json;charset=UTF-8"
          }
        }).then((response) => {
          StorageService.setLocalStorageObject('currentWallet', walletId);
          checkLogin(response, resolve);
        }, error => {
          $log.debug('error while switching token', error);
          reject('common.errors.generic');
        });

    }),
    
    login: (username, password, doubleProfile, walletId, access_token) => $q((resolve, reject) => {
      service.softLogout();

      const loginError = (message, reason) => {
        $log.error('LoginService', 'login', message, reason);
        // ValidazioneService.addTranslatedError(message);
        reject(message);
      };

    
      var body;
      var normalizedUsername;
      if(!doubleProfile){
        normalizedUsername = username;
        if(/^\d+$/.test(normalizedUsername)){
          if (!/^\+39/.test(normalizedUsername)) {
            normalizedUsername = `+39${username}`;
          }
        }
        body = $.param({
          'grant_type': 'password',
          'username': normalizedUsername,
          password
        });
      }else{
        body = $.param({
          'grant_type': 'switch_token',
          "client_id": "webapp",
          "activeWalletId" : walletId,
          "access_token": access_token
        });
      }
      

      $http.post(`${endPoints.baseUrl}${endPoints.authenticatorUrl}`,
        body 
        , {
          ignoreAuthModule: true,
          customErrorManagement: true,
          headers: {
            'Authorization': 'Basic d2ViYXBwOndlYmFwcF9zZWNyZXQ=',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': "application/json;charset=UTF-8"
          }
        }).then((response) => {
        checkLogin(response, resolve, loginError, doubleProfile);
      }, (error) => {
        $log.debug('errore login', error);
          if(error.status == 400 && error.data.error_description === 'Bad credentials'){
            reject('login.errors.credentials');
          }else if(error.status == 401 && error.data.error_description != null){
            var date = error.data.error_description.match(/\d+/g).map(Number).length > 0 ? error.data.error_description.match(/\d+/g).map(Number)[0] : undefined;
            if(date){
              var d = new Date(Date.parse(date));
              error.data.error_description = error.data.error_description.replace(date, $filter('date')(date, "dd/MM/yyyy hh:mm"))
            }
            reject(error.data.error_description)
          }else{
            reject('common.errors.generic');
          }
        // reject(reason);
      });
    }),
   
    softLogout: () => {
      NewTokenService.clearAllStorages();
      NewTokenService.doReset();
      StoreService.clean();
      console.log("SOFTLOGOUT")
      console.log("selectedStore: "+StoreService.selectedStore)
      merchantProfile = undefined;
      Dispatcher.dispatch({
        actionType: 'GLOBAL_CLEAN'
      });

      $rootScope.$broadcast('USER_LOGGED_OUT');
    },
    
    superAdminUpgrade: (merchant) => $q((resolve, reject) => {
      var id = merchant.ownerId;
      var businessId = merchant.id;
      NewMerchantProfileService.getMerchantProfile(true, false, id).then((merchantProfileResult) => {
        NewMerchantProfileService.getMerchantBusiness(businessId, id).then((resp) => {
          merchantProfile = merchantProfileResult;
          if(resp.data._embedded)
              merchantProfile.business = resp.data._embedded.businesses.length > 0 ? resp.data._embedded.businesses[0] : {};
            else{
              merchantProfile.business = resp.data;
            } 
          merchantProfile.businessId = merchantProfile.business.id;
          merchantProfile.profile = merchantProfile.business.wallet.type;
          merchantProfile.walletId = merchantProfile.business.wallet.id;
          merchantProfile.walletLevel = merchantProfile.business.wallet.level;
          merchantProfile.walletType = merchantProfile.business.wallet.type;

          StorageService.setLocalStorage("userContext", JSON.stringify(merchantProfile));
          
          console.log("SUPER ADMIN UPGRADE")
          console.log("selectedStore: "+StoreService.selectedStore)

          StoreService.getStoreList().then(() => {
            console.log("SUPER ADMIN UPGRADE INSIDE GETSTORE")
            console.log("selectedStore: "+StoreService.selectedStore)
                $rootScope.$broadcast("$storeChangeSuccess");
                resolve(merchantProfile);
              })
            }, (reason) => {
              $log.error('LoginController', 'login', reason);
        })
      }, reject);
    }),
    
    renewToken: () => $q((resolve, reject) => {

      const googleJwt = StorageService.getLocalStorage("access_token"); 

      $http.post(`${endPoints.baseUrl}${endPoints.authenticatorUrl}`,
        $.param({
          'grant_type': 'refresh_token',
          'refresh_token': MODE == "admin" ? "none" : StorageService.getLocalStorage('refresh_token')
        }), {
          ignoreAuthModule: true,
          customErrorManagement: true,
          headers: {
            Authorization: MODE == "admin" ? `Basic ${googleJwt}` : 'Basic d2ViYXBwOndlYmFwcF9zZWNyZXQ=',
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          NewTokenService.setLastUserAction();
          StorageService.setLocalStorage('access_token', response.data.access_token);
          StorageService.setLocalStorage('refresh_token', response.data.refresh_token);
          resolve();
        }, () => {
          reject();
        })
    }),

    getUserRole: () => {
      var token = jwtHelper.decodeToken(StorageService.getLocalStorage('access_token'))
      return token.authorities
    }
    

  };

  return service;
};

export default LoginServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/login.factory.js
 **/